module.exports = __webpack_public_path__ + "img/IMG_0499.75ba56da.jpg";